import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const ChlorineTableDataAPI = createAsyncThunk("ChlorineTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_JunctionID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        DashProjectTypeId,
        RoleID,
        // handleGetPDFUrl
        handleWaterSupplyChlorineExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let Url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        Url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterQualityChlorine_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        Url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterQualityChlorine_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }

    return fetch(Url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleWaterSupplyChlorineExport && handleWaterSupplyChlorineExport()
                // { Flag == 'Report' && handleGetPDFUrl(result.url) }
                return result.data
            } else {
                return result
            }
        })
})

const ChlorineTableDataSlice = createSlice({
    name: "ChlorineTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ChlorineTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ChlorineTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(ChlorineTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ChlorineTableDataReducer = ChlorineTableDataSlice.reducer

// PDF REPORT

export const ChlorinePDFReportTableDataAPI = createAsyncThunk("ChlorinePDFReportTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_JunctionID,
        M_UserID,
        token,
        From,
        To,
        DashProjectTypeId,
        RoleID,
        Flag,
        // handleGetPDFUrl
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let Url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        Url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterQualityChlorine_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        Url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterQualityChlorine_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`
    }

    return fetch(Url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                // { Flag == 'Report' && handleGetPDFUrl(result.url) }
                return result.data
            } else {
                return result
            }
        })
})

const ChlorinePDFReportTableDataSlice = createSlice({
    name: "ChlorinePDFReportTableData",
    initialState: {
        isLoading: false,
        pdftableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ChlorinePDFReportTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ChlorinePDFReportTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.pdftableData = action.payload;
        });
        builder.addCase(ChlorinePDFReportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.pdftableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ChlorinePDFReportTableDataReducer = ChlorinePDFReportTableDataSlice.reducer


export const ChlorineTableExportDataAPI = createAsyncThunk("ChlorineTableExportData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_JunctionID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        DashProjectTypeId,
        RoleID,
        // handleGetPDFUrl
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let Url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        Url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterQualityChlorine_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {

        Url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterQualityChlorine_RM_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`

        // Url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterQualityChlorine_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }

    return fetch(Url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // if (result.code >= 200 && result.code <= 300 && result.data) {
            //     // { Flag == 'Report' && handleGetPDFUrl(result.url) }
            //     return result.data
            // } else {
            //     return result
            // }

            if (DashProjectTypeId == '6' && RoleID != '16') {
                if (result.code >= 200 && result.code <= 300 && result.data) {
                    // { Flag == 'Report' && handleGetPDFUrl(result.url) }
                    return result.data
                } else {
                    return result
                }
            } else {
                if (result.code >= 200 && result.code <= 300 && result.data_Report) {
                    // { Flag == 'Report' && handleGetPDFUrl(result.url) }
                    return result.data_Report
                }
            }
        })
})

const ChlorineTableExportDataSlice = createSlice({
    name: "ChlorineTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ChlorineTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(ChlorineTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(ChlorineTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ChlorineTableExportDataReducer = ChlorineTableExportDataSlice.reducer



export const ChlorinePostDataAPI = createAsyncThunk("PumpingStationPostData", async ({ data }) => {
    const {
        T_WS_WaterQualityChlorineID,
        InletChlorine,
        OutChlorine,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
        DashProjectTypeId,
        T_Distri_WaterQualityChlorineID,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterQualityChlorineID", T_Distri_WaterQualityChlorineID);
    } else {
        formdata.append("T_WS_WaterQualityChlorineID", T_WS_WaterQualityChlorineID);
    }

    formdata.append("InletChlorine", InletChlorine);
    formdata.append("OutChlorine", OutChlorine);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_Distri_WaterQualityChlorine_Update`
    } else {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_WS_WaterQualityChlorine_Update`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const ChlorinePostDataSlice = createSlice({
    name: "ChlorinePostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ChlorinePostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ChlorinePostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(ChlorinePostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const ChlorinePostDataReducer = ChlorinePostDataSlice.reducer

// -----------------Delete API ---------------

export const ChlorineDeleteAPI = createAsyncThunk("ChlorineDelete", async ({ data }) => {
    const {
        T_WS_WaterQualityChlorineID,
        M_UserID,
        token,
        handleIsPost,
        DashProjectTypeId,
        T_Distri_WaterQualityChlorineID,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterQualityChlorineID", T_Distri_WaterQualityChlorineID);
    } else {
        formdata.append("T_WS_WaterQualityChlorineID", T_WS_WaterQualityChlorineID);
    }
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_Distri_WaterQualityChlorine_Delete`
    } else {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_WS_WaterQualityChlorine_Delete`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const ChlorineDeleteSlice = createSlice({
    name: "ChlorineDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ChlorineDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(ChlorineDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(ChlorineDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const ChlorineDeleteReducer = ChlorineDeleteSlice.reducer